module.exports = __webpack_public_path__ + "media/student_loans/SallieMae_infographic-11fda453.jpg";